module.exports = __webpack_public_path__ + "img/2.dc29a5d3.jpg";